/*
 * Copyright (c) 2018 OCLC, Inc. All Rights Reserved.
 *
 * OCLC proprietary information: the enclosed materials contain proprietary information of OCLC Online Computer
 * Library Center, Inc. and shall not be disclosed in whole or in any part to any third party or used by any person
 * for any purpose, without written consent of OCLC, Inc.  Duplication of any portion of these materials shall include
 * this notice.
 */
import {api} from '../api';
import * as t from './actionTypes';

const API_ENDPOINT = 'api/applications';

/**
 * Fetch all applications, then dispatch a LIST_APPLICATIONS_REQUEST_COMPLETE action to add them all
 * to the app state.
 */
export function fetchApplications () {
  return dispatch => {
    dispatch({type: t.LIST_APPLICATIONS_REQUEST});

    return api(API_ENDPOINT, {method: 'GET'})
      .then(response => response.json())
      .then((json) => {
        dispatch(requestApplicationsSuccess(json));
      });
  };
}

/**
 * Action creator for listing the user's applications.
 *
 * @param applications
 * @returns {{type: string, applications: *}}
 */
export const requestApplicationsSuccess = (applications) => {
  return {
    type: t.LIST_APPLICATIONS_REQUEST_COMPLETE,
    applications
  };
};



// WEBPACK FOOTER //
// ./src/applications/actions.js